import { DeliveryMethodNames, OrderOnSpotCustomMethod } from '@eo-storefronts/eo-core'
import { useEffect, useState } from 'react'
import { useEoValue } from '~/src/hooks/useEoState'
import { useTranslations } from '~/src/hooks/useTranslations'
import { CHECKOUT_FORM_STATE } from '~/src/stores/checkout'
import { FIRM_SELECTOR } from '~/src/stores/firm'

interface ReturnsType {
  sentence: string,
}

const useEatInLocationInline = (): ReturnsType => {
  const { t } = useTranslations()
  const checkoutForm = useEoValue(CHECKOUT_FORM_STATE)
  const firm = useEoValue(FIRM_SELECTOR)
  const [ sentence, setSentence ] = useState<string>('')

  useEffect(() => {
    if (
      !firm
      || (
        !checkoutForm.delivery_method.table_number
        && firm?.settings.delivery_methods[DeliveryMethodNames.ON_THE_SPOT]?.number_required
      )
    ) {
      setSentence(t('delivery_methods.choose_your_spot'))
      return
    }

    if (!checkoutForm.delivery_method.table_method && checkoutForm.delivery_method.table_number) {
      setSentence(`${firm.labels?.at_table} (${firm.labels?.table_number} #${checkoutForm.delivery_method.table_number})`)
      return
    }

    if (!checkoutForm.delivery_method.table_method && !checkoutForm.delivery_method.table_number) {
      setSentence(firm.labels?.at_table || '')
      return
    }

    const eatInLocation = firm.settings.delivery_methods[DeliveryMethodNames.ON_THE_SPOT]?.custom_methods?.find(
      (customMethod: OrderOnSpotCustomMethod) => customMethod.id === checkoutForm.delivery_method.table_method
    )

    eatInLocation && setSentence(`${eatInLocation.name} (${eatInLocation.location_number_name} #${checkoutForm.delivery_method.table_number})`)
  }, [
    firm,
    checkoutForm.delivery_method.table_number,
    checkoutForm.delivery_method.table_method
  ])

  return { sentence }
}

export {
  useEatInLocationInline
}
